import React from 'react';
interface ToggleProps {
  checked: boolean;
  onChange: () => void;
  label: string;
  disabled?: boolean;
  id?: string;
}
export function Toggle({
  checked,
  onChange,
  label,
  disabled = false,
  id
}: ToggleProps) {
  return <button type="button" id={id} role="switch" aria-checked={checked} aria-label={label} disabled={disabled} onClick={onChange} className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border transition-colors duration-150 ease-snap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand ${checked ? 'border-brand bg-brand' : 'border-line-strong bg-paused-soft'} ${disabled ? 'cursor-not-allowed opacity-50' : ''}`} data-id="element-492" data-mp="17wvn766t305r">
      <span className={`ml-0.5 inline-block h-4 w-4 rounded-full bg-white shadow-card transition-transform duration-150 ease-snap ${checked ? 'translate-x-4' : 'translate-x-0'}`} data-id="element-493" data-mp="f9reaq4le1op" />
    </button>;
}